import React, { FC } from 'react'
import Box from '@material-ui/core/Box'
import Alert from '@material-ui/lab/Alert'
import DocumentVerificationIcon from 'components/DocumentVerificationIcon'
import { getVerificationNotices } from 'utils/documentVerificationHelpers'
import { DocumentVerificationStatus } from 'typescript/enums/documentVerification'
import { IClientDocumentVerification } from 'typescript/interfaces/documentVerification'

interface IDocumentVerificationNoticesProps {
  verification: IClientDocumentVerification | undefined
}

const DocumentVerificationNotices: FC<IDocumentVerificationNoticesProps> = ({ verification }) => {
  if (!verification || verification.status === DocumentVerificationStatus.pending) return null

  return (
    <>
      {getVerificationNotices(verification).map(notice => (
        <Box key={notice.message} mt="1rem">
          <Alert severity={notice.severity} icon={<DocumentVerificationIcon severity={notice.severity} />}>
            {notice.message}
          </Alert>
        </Box>
      ))}
    </>
  )
}

export default DocumentVerificationNotices
